import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "/_/backend";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const adminApi = (key) =>
  axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json", "X-Admin-Key": key },
  });

import links from "../links.json";

export const SITE = {
  domain: "https://drashishgupta.co.in",
  name: "Dr. Ashish Gupta | WellMed Hospitals",
  description: "WellMed Hospitals - Dr. Ashish Gupta | Senior Interventional Cardiologist",
  doctorName: "Dr. Ashish Gupta",
  tagline: "Expertise & Excellence in Interventional Cardiology",
  phone: "+917289999292",
  phoneDisplay: "072899 99292",
  whatsapp: links.whatsapp || "917289999292",
  email: "info@wellmedhospitals.com",
  address: "Wellmed Hospitals, 242, Sector 39, Gurugram, Haryana 122003",
  rating: "4.9",
  reviewCount: "500+",
  yearsExp: "20+",
  babiesDelivered: "10,000+", // Keeping the key name the same so we don't break existing components, but updating the value to interventions.
  youtube: links.youtube,
  instagram: links.instagram,
  facebook: links.facebook,
  practo: links.practo,
  googleReviews: links.googleReviews,
  sheetsLink: links.sheetsLink,
  googleMaps: links.googleMaps || "https://maps.google.com/?q=Wellmed+Hospitals+Sector+39+Gurugram",
  googleMapsEmbed: links.googleMapsEmbed || "https://www.google.com/maps?q=Wellmed+Hospitals+Sector+39+Gurugram&output=embed"
};

export const whatsappLink = (text = "Hello, I would like to book an appointment with Dr. Ashish Gupta.") =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(text)}`;
